import { ReactNode } from 'react'
import { ChevronLeftIcon } from '~/components/icons/generated/ChevronLeftIcon'
import { ChevronRightIcon } from '~/components/icons/generated/ChevronRightIcon'
import { getPcPaginationIndexes } from './getPcPaginationIndexes'

type Props = {
  totalPage: number
  currentPage: number
  buildUrl: (page: number) => string | undefined
}

const AnchorButton: React.FC<{
  href?: string
  ariaLabel: string
  children?: ReactNode
}> = ({ href, ariaLabel, children }) => {
  const className =
    'flex h-11 justify-center items-center w-[30%] rounded xl:w-[90px] xl:rounded-[3px] xl:h-[32px]'
  return href === undefined ? (
    <div
      className={`${className} bg-gray-100 text-gray-600 xl:bg-gray-200 xl:text-gray-500`}
    >
      {children}
    </div>
  ) : (
    <a
      href={href}
      className={`${className} bg-blue-400 text-white hover:opacity-60`}
      aria-label={ariaLabel}
    >
      {children}
    </a>
  )
}

export const Pagination: React.FC<Props> = ({
  totalPage,
  currentPage,
  buildUrl,
}) => (
  <div className="flex w-full items-center px-[10px] xl:h-auto xl:justify-end xl:gap-3 xl:p-0">
    <AnchorButton href={buildUrl(currentPage - 1)} ariaLabel="前のページ">
      <ChevronLeftIcon className="h-6" />
    </AnchorButton>
    <div className="flex grow flex-col items-center justify-center leading-[1.4] xl:hidden">
      <span className="text-[15px]">
        {currentPage} / {totalPage}
      </span>
      <span className="text-[12px]">ページ</span>
    </div>
    <ul className="hidden h-[18px] divide-x border-gray-300 xl:flex">
      {getPcPaginationIndexes(currentPage, totalPage).map((page, i) => {
        const isCurrentPage = page === currentPage
        return (
          <li key={i}>
            {!isCurrentPage && page !== '...' ? (
              <a
                href={buildUrl(page)}
                className="flex items-center justify-center px-3 text-[16px] font-bold leading-none text-blue-400 hover:underline"
              >
                {page}
              </a>
            ) : (
              <span className="flex items-center justify-center px-3 text-[16px] font-bold leading-none text-gray-500">
                {page}
              </span>
            )}
          </li>
        )
      })}
    </ul>
    <AnchorButton href={buildUrl(currentPage + 1)} ariaLabel="次のページ">
      <ChevronRightIcon className="h-6" />
    </AnchorButton>
  </div>
)
